/**
 * Lightweight replacement for next/image in Vite.
 */
export function AppImage({ src, alt, width, height, className, priority, fill, ...rest }) {
  const style = fill
    ? { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    : undefined;

  return (
    <img
      src={src}
      alt={alt ?? ""}
      width={width}
      height={height}
      className={className}
      style={style}
      loading={priority ? "eager" : "lazy"}
      {...rest}
    />
  );
}
